import { template } from "@ember/template-compiler";
import { type TOC } from '@ember/component/template-only';
import { get } from '@ember/object';
import type { ComponentLike } from '@glint/template';
import type Patient from 'parog-web/models/patient';
import ObservanceAndPersistencePage from './content/observance-and-persistence-page';
import NephroTransplant from './nephro-transplant';
interface Signature {
    Args: {
        patient: Patient;
    };
}
const DefaultPage: TOC<Signature> = template(`
  <ObservanceAndPersistencePage @patient={{@patient}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const Pages: Record<string, ComponentLike<Signature>> = {
    'mental-bipolar': DefaultPage,
    'onco-breast-cancer': DefaultPage,
    'onco-breast-cancer-tnm0': DefaultPage,
    'nephro-transplant': NephroTransplant
};
const ScoreResultPage: TOC<Signature> = template(`
  {{#let (get Pages @patient.followUpReason) as |FurComponent|}}
    {{#if FurComponent}}<FurComponent @patient={{@patient}} />{{/if}}
  {{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default ScoreResultPage;
